import { isAnswerFilled, isFollowUpVisible, isQuestionVisible, } from "./visibility.js";
export const collectVisibleFields = (schema, answers) => {
    const fields = [];
    for (const section of schema.sections) {
        for (const subStep of section.subSteps) {
            if (subStep.customKind)
                continue;
            for (const question of subStep.questions) {
                if (!isQuestionVisible(question, answers))
                    continue;
                fields.push(...(question.fields ?? (question.field ? [question.field] : [])));
                if (isFollowUpVisible(question, answers)) {
                    fields.push(...(question.followUpFields ?? []));
                }
            }
        }
    }
    return fields;
};
/**
 * Die EINE Zählung hinter jeder Fortschrittsanzeige.
 *
 * `optional` markierte Felder zählen weder im Zähler noch im Nenner. Gedacht
 * ist das für die Upload-Slots („Erforderliche Unterlagen"): Wer keinen
 * Brandschutzbericht hat, hat auch keinen hochzuladen — sein Formular ist
 * trotzdem fertig. Zählten die Slots mit, endete jede Analyse ohne Unterlagen
 * bei ~85 % und der Kunde suchte die fehlenden 15 %.
 *
 * Der Filter sitzt bewusst NUR hier und nicht in {@link collectVisibleFields}:
 * gerendert, gespeichert und in der Zusammenfassung gezeigt wird ein
 * optionales Feld ganz normal.
 *
 * **Warum die Rohzahlen exportiert sind.** Nicht jede Anzeige ist ein
 * Prozentwert: `apps/web/src/pages/RisikoKfzStepForm.tsx` schreibt „12 von 15"
 * und zählte dafür bis hierher selbst über {@link collectVisibleFields} — ohne
 * `optional` zu kennen. Sobald das Flag in einem Schema benutzt wird, meldete
 * die eine Leiste 100 % und die andere daneben „12 von 15". Beide Anzeigen
 * kommen jetzt aus dieser Funktion.
 */
export function formProgressCounts(schema, answers) {
    const zaehlende = collectVisibleFields(schema, answers).filter((field) => !field.optional);
    return {
        total: zaehlende.length,
        answered: zaehlende.filter((field) => isAnswerFilled(answers[field.key]))
            .length,
    };
}
/**
 * Fortschritt in Prozent über alle SICHTBAREN Pflichtfelder.
 *
 * Sonderfall „nichts zu zählen": Sind Felder sichtbar, aber ALLE `optional`,
 * dann ist auch nichts mehr offen — das sind 100 % und nicht 0 %. Ein Schema
 * (oder eine künftige Aufteilung), dessen sichtbare Felder ausschliesslich
 * Upload-Slots sind, zeigte dem Kunden sonst dauerhaft 0 %, obwohl er nichts
 * mehr tun kann. Nur wenn überhaupt kein Feld sichtbar ist — leeres oder
 * vollständig ausgeblendetes Schema — bleibt es bei 0 %: dort ist „fertig"
 * keine ehrliche Aussage, sondern ein Anzeigefehler, den niemand bemerken
 * würde.
 */
export function computeFormProgress(schema, answers) {
    const { total, answered } = formProgressCounts(schema, answers);
    if (total === 0) {
        return collectVisibleFields(schema, answers).length > 0 ? 100 : 0;
    }
    return Math.round((answered / total) * 100);
}
